import React from "react"
import Grid, { GridProps } from "@material-ui/core/Grid"

const GridContainer = (props: GridProps) => <Grid container spacing={1} {...props} />

export default GridContainer